import { createFileRoute } from "@tanstack/react-router";
import { PlatformSchedulerPage } from "@/components/platform-scheduler-page";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/channels/tiktok";

export const Route = createFileRoute(path)({
	component: TikTokScheduler,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "AgentReacher | Connect your AI agent to TikTok",
			description:
				"Schedule TikTok videos with an AI social media agent. Generate captions, hashtags, and a weekly TikTok calendar from one prompt.",
		}),
});

function TikTokScheduler() {
	return (
		<PlatformSchedulerPage
			platform="tiktok"
			platformLabel="TikTok"
			hero={{
				title: "Connect your AI agent to TikTok",
				description:
					"Upload your videos or describe the campaign. AgentReacher writes TikTok-native captions, picks hashtags, and turns the plan into a review-ready publishing calendar.",
			}}
		/>
	);
}
